"use strict";

var _classCallCheck = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MemoryStorage =
/*#__PURE__*/
function () {
  function MemoryStorage() {
    _classCallCheck(this, MemoryStorage);

    this.store = {};
  }

  _createClass(MemoryStorage, [{
    key: "getItem",
    value: function getItem(key) {
      return Promise.resolve(this.store[key]);
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      return Promise.resolve(this.store[key] = value);
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      var value = this.store[key];
      delete this.store[key];
      return Promise.resolve(value);
    }
  }]);

  return MemoryStorage;
}();

exports.MemoryStorage = MemoryStorage;

var StorageWrapper =
/*#__PURE__*/
function () {
  function StorageWrapper(storage) {
    _classCallCheck(this, StorageWrapper);

    this.storage = storage;
  }

  _createClass(StorageWrapper, [{
    key: "getItem",
    value: function getItem(key) {
      return Promise.resolve(this.storage.getItem(key));
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      return Promise.resolve(this.storage.setItem(key, value));
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      return Promise.resolve(this.storage.removeItem(key));
    }
  }]);

  return StorageWrapper;
}();

exports.StorageWrapper = StorageWrapper;